import { Topbar } from "components/ui/shared/Topbar";
import { Outlet, useMatches } from "react-router-dom";
import styled from "styled-components"

export const Tools = () => {

    
    const matches = useMatches();
    const currentMatch = matches[matches.length-1];

    return (
        <>
            <Topbar breacrumb={["Verktøy", currentMatch?.handle?.title || "Ukjent"]}>
                <div style={{height: '32px'}}/>
            </Topbar>
            <StyledTools>
                <div className="toolsHeader">
                    {currentMatch?.handle?.title || "Ukjent"}
                </div>
                <div className="toolsContent">
                    <Outlet/>
                </div>
            </StyledTools>
        </>
        
    )
}

const StyledTools = styled.div`

    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    div.toolsHeader
    {
        margin-bottom: ${({theme}) => theme.spacing.lg};
        font-size: ${({theme}) => theme.fontSize.xxl};
        font-weight: 500;
        display: block;
        margin-bottom: ${({theme}) => theme.spacing.lg};
    }

    div.toolsContent
    {
        flex: 1 1 auto;
        overflow: auto;
        display: flex;
        gap: ${({theme}) => theme.spacing.lg};
        min-height: 0;
    }
`